// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__3Q4fI","h1":"Header_h1__2i6ET","img":"Header_img__3TsRr"};